import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { api, API } from "../lib/api";

export default function Leads() {
  const [data, setData] = useState({ total: 0, items: [] });
  const [campaigns, setCampaigns] = useState([]);
  const [cid, setCid] = useState("");
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/leads", { params: { campaign_id: cid || undefined, q: q || undefined } }).then((r) => setData(r.data));
  useEffect(() => { load(); }, [cid]);
  useEffect(() => { api.get("/admin/campaigns").then((r) => setCampaigns(r.data)); }, []);

  const exportCsv = async () => {
    const token = localStorage.getItem("craft_token");
    const res = await fetch(`${API}/admin/leads/export${cid ? `?campaign_id=${cid}` : ""}`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "leads.csv";
    a.click();
  };

  return (
    <div className="space-y-4" data-testid="admin-leads">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h1 className="font-display font-black text-2xl">Заявки / Ответы <span className="text-sm text-gray-400 font-bold">({data.total})</span></h1>
        <button data-testid="leads-export-btn" className="admin-btn admin-btn-ghost text-xs" onClick={exportCsv}><Download size={13} /> Export CSV</button>
      </div>
      <div className="flex gap-2 flex-wrap">
        <select data-testid="leads-campaign-filter" className="admin-input !w-56" value={cid} onChange={(e) => setCid(e.target.value)}>
          <option value="">Все кампании</option>
          {campaigns.map((c) => <option key={c.id} value={c.id}>{c.name?.ru}</option>)}
        </select>
        <input data-testid="leads-search-input" className="admin-input !w-64" placeholder="Поиск..." value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} />
      </div>
      <div className="bg-white rounded-2xl border border-gray-100 overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]">
          <thead><tr className="text-left text-xs text-gray-400 uppercase">
            <th className="px-4 py-3">Дата</th><th>Кампания</th><th>Имя</th><th>Телефон</th><th>Email</th><th>Верификация</th><th>Данные</th>
          </tr></thead>
          <tbody>
            {data.items.map((l) => (
              <tr key={l.id} className="border-t border-gray-50 align-top" data-testid={`lead-row-${l.id}`}>
                <td className="px-4 py-2.5 text-xs text-gray-400">{l.created_at?.slice(0, 16).replace("T", " ")}</td>
                <td className="font-bold">{l.campaign_name} <span className="text-xs text-gray-400">({l.campaign_type})</span></td>
                <td>{l.data?.first_name || "—"}</td>
                <td>{l.data?.phone || "—"}</td>
                <td>{l.data?.email || "—"}</td>
                <td>{l.verified_via || "—"}</td>
                <td className="text-xs text-gray-500 max-w-[280px]">
                  {Object.entries(l.data || {}).filter(([k]) => !["first_name", "phone", "email"].includes(k)).map(([k, v]) => `${k}: ${v}`).join(" · ")}
                  {l.customer_id && <Link to={`/admin/customers/${l.customer_id}`} className="text-[#FF0000] font-bold ml-1">→ профиль</Link>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
